import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CONSTANTS } from '../../data';
import { sounds } from '../../systems/AudioSystem';

interface ResetConfirmationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ResetConfirmationModal: React.FC<ResetConfirmationModalProps> = ({ isOpen, onConfirm, onCancel }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="reset-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            className="reset-modal"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          >
            <h2 className="reset-title">{CONSTANTS.RESET_CONFIRMATION.title}</h2>
            <p className="reset-text">{CONSTANTS.RESET_CONFIRMATION.message}</p>
            <div className="reset-buttons">
              <button className="reset-cancel-btn" onClick={onCancel} onMouseEnter={() => sounds.menuHover()}>
                {CONSTANTS.RESET_CONFIRMATION.cancelButtonText}
              </button>
              <button className="reset-confirm-btn" onClick={onConfirm} onMouseEnter={() => sounds.menuHover()}>
                {CONSTANTS.RESET_CONFIRMATION.confirmButtonText}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
